const AccountFileType = {
    ClinicalNote: 1,
    Invoice: 2,
    TheatreTrendPrintOut: 3,
    //Referral: 4,
    TheatreClinicalNotes: 5,
    LabResults: 6,
    LetterOfMotivation: 7,
    ReferralLetter: 8,
    LOM: 9,
    GOP: 10,
    ProofOfReceptionByPatient: 11,
    Script: 12,
    Report: 13,
    ICUNote: 14,
    DeclarationStatement: 15,
    //DeclarationStatement: 15
    AccountStatement: 16,
    RAF_EMSAccidentInformationForm: 17,
    ClinicalNoteIAOne: 18,
    ClinicalNoteIATwo: 19,
    Communication: 20,
    TransferCaseProfile: 21,
    ClinicalNotePROne: 22,
};

export default AccountFileType;
